import { addItems, cartEvent } from './clauspop-cart.js';

// Keep the slide position across Horizon's section hydration/morph updates.
const state = { nextProduct: null, busy: false, busyProduct: null, cart: null, error: '' };
class ClausPopUpsells extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-upsell-prev]')) this.move(-1);
      if (event.target.closest('[data-upsell-next]')) this.move(1);
      const button = event.target.closest('[data-upsell-add]');
      if (button) this.add(button);
    }, { signal });
    this.addEventListener('change', (event) => {
      if (event.target.matches('[data-upsell-variant]')) {
        const card = event.target.closest('[data-upsell-card]');
        card.querySelector('[data-upsell-price]').textContent = event.target.selectedOptions[0].dataset.price;
      }
    }, { signal });
    document.addEventListener('clauspop:cart', (event) => { state.cart = event.detail; this.refresh(); }, { signal });
    document.addEventListener(cartEvent, (event) => {
      event.promise?.then(({ detail }) => {
        if (detail?.items) { state.cart = { items: detail.items }; this.refresh(); }
      }).catch(() => {});
    }, { signal });
    this.observer = new MutationObserver(() => this.refresh());
    this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'data-product-id'] });
    this.refresh();
  }
  disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  refresh() {
    const status = this.querySelector('[data-upsell-status]');
    if (status && status.textContent !== state.error) status.textContent = state.error;
    const all = [...this.querySelectorAll('[data-upsell-card]')];
    const inCart = state.cart ? new Set(state.cart.items.map((item) => String(item.product_id))) : null;
    this.cards = all.filter((card) => !inCart?.has(card.dataset.productId));
    const empty = this.cards.length === 0;
    if (this.hidden !== empty) this.hidden = empty;
    this.index = Math.max(0, this.cards.findIndex((card) => card.dataset.productId === state.nextProduct));
    all.forEach((card) => {
      const hidden = card !== this.cards[this.index];
      if (card.hidden !== hidden) card.hidden = hidden;
    });
    if (empty) return;
    for (const control of this.querySelectorAll('[data-upsell-prev],[data-upsell-next]')) {
      const hidden = this.cards.length < 2;
      if (control.hidden !== hidden) control.hidden = hidden;
    }
    this.querySelectorAll('[data-upsell-add]').forEach((button) => {
      button.disabled = state.busy;
      const pending = state.busy && button.closest('[data-upsell-card]').dataset.productId === state.busyProduct;
      const text = pending ? 'Adding…' : this.dataset.addLabel || 'Add';
      if (button.textContent !== text) button.textContent = text;
      button.setAttribute('aria-busy', String(pending));
    });
    const count = this.querySelector('[data-upsell-count]');
    const label = `${this.index + 1} of ${this.cards.length}`;
    if (count && count.textContent !== label) count.textContent = label;
  }
  move(delta) {
    if (state.busy || !this.cards.length) return;
    this.index = (this.index + delta + this.cards.length) % this.cards.length;
    state.nextProduct = this.cards[this.index].dataset.productId;
    this.refresh();
  }
  async add(button) {
    if (state.busy) return;
    const card = button.closest('[data-upsell-card]');
    const id = card.querySelector('[data-upsell-variant]')?.value || button.dataset.variantId;
    if (!id) return;
    const status = this.querySelector('[data-upsell-status]');
    const next = this.cards[(this.index + 1) % this.cards.length];
    state.nextProduct = card.dataset.productId;
    state.busyProduct = card.dataset.productId;
    state.busy = true;
    state.error = '';
    status.textContent = '';
    this.refresh();
    button.textContent = 'Adding…';
    const variantOption = card.querySelector('[data-upsell-variant]')?.selectedOptions[0];
    try {
      await addItems(this, [{ id: Number(id), quantity: Number(variantOption?.dataset.quantity || button.dataset.quantity) || 1 }]);
      state.nextProduct = next?.dataset.productId;
    }
    catch (error) {
      state.error = error.message;
      // The server may have replaced this element after an add succeeded but a read failed.
      for (const el of document.querySelectorAll('clauspop-upsells')) {
        const message = el.querySelector('[data-upsell-status]');
        if (message) message.textContent = error.message;
      }
      state.nextProduct = card.dataset.productId;
    }
    finally {
      state.busy = false; state.busyProduct = null;
      document.querySelectorAll('clauspop-upsells').forEach((el) => {
        el.querySelectorAll('[data-upsell-add]').forEach((btn) => { btn.textContent = el.dataset.addLabel || 'Add'; });
        el.refresh();
      });
    }
  }
}
if (!customElements.get('clauspop-upsells')) customElements.define('clauspop-upsells', ClausPopUpsells);

document.addEventListener('clauspop:notice', (event) => {
  const node = document.querySelector('[data-cp-cart-notice]');
  if (node) { node.textContent = event.detail; node.hidden = !event.detail; }
});
